import {
  useGetInstallationDeliveriesQuery,
  useRemoveDeliveryMutation
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  dateReceived: DateTime | null ;
}

export function useQuery(installationId: string) {
  const tuple = useGetInstallationDeliveriesQuery({
    variables: {
      id: installationId
    },
    skip: installationId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.installation?.associatedDeliveries.map((node) => ({
        id: node.id ?? '',
        dateReceived: node.receivedDate ?? null,
        name: node.name ?? ''
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

export function useRemoveDelivery() {
  const [
    fnMutate,
    tuple
  ] = useRemoveDeliveryMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
